<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-form @submit.prevent="addItem">
          <b-row>
            <b-col cols="12" class="mb-3">
              <b-button variant="primary" @click="$router.go(-1)" class="pull-left">Terug</b-button>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-alert variant="danger" :show="errors && !errors.empty">
                Er ging iets mis...
                <ul class="mt-3">
                  <li v-for="error in errors">{{error.toString()}}</li>
                </ul>
              </b-alert>
              <b-card>
                <template #header>
                  <strong>Nieuwe gebruiker</strong>
                </template>
                <b-row>
                  <b-col cols="12" sm="10" md="6">
                    <b-row>
                      <b-col cols="12" md="8">
                        <h5>Basisgegevens</h5>
                        <hr>
                      </b-col>
                      <b-col cols="12" md="6">
                        <b-form-group label="Naam">
                          <b-form-input type="text" required v-model="item.name"></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6">
                        <b-form-group label="E-mailadres">
                          <b-form-input type="email" required v-model="item.email"></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6">
                        <b-form-group label="Rechtenprofiel">
                          <b-form-select :options="roleOptions" v-model="item.role"></b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row class="mt-4" v-if="['Manager', 'Analyst', 'Filiaalmanager', 'Gebruiker'].indexOf(item.role) > -1">
                      <b-col cols="12" md="8">
                        <h5 v-if="['Manager', 'Analyst'].indexOf(item.role) > -1">Bedrijf</h5>
                        <h5 v-if="['Filiaalmanager', 'Gebruiker'].indexOf(item.role) > -1">Locatie</h5>
                        <hr>
                      </b-col>
                      <b-col cols="12" md="6" v-if="['Manager', 'Analyst'].indexOf(item.role) > -1">
                        <b-form-group label="Gekoppeld bedrijf">
                          <b-form-select :options="companyOptions" v-model="item.company_id"></b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6" v-if="['Filiaalmanager', 'Gebruiker'].indexOf(item.role) > -1">
                        <b-form-group label="Gekoppelde locatie">
                          <b-form-select :options="locationOptions" v-model="item.location_id"></b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" sm="10" md="6">
                    <b-row>
                      <b-col cols="12" md="8">
                        <h5>Permissies</h5>
                        <hr>
                      </b-col>
                      <b-col cols="12" md="6" class="mt-2 mb-4" v-if="item.role && portalPermissions">
                        <b-form-checkbox-group :options="portalPermissions" :checked="activePortalPermissions" :disabled="true" stacked></b-form-checkbox-group>
                      </b-col>
                      <b-col cols="12" md="10" class="mt-2 mb-4" v-else>
                        <p style="font-style: italic; color: #73818f;">Selecteer een rechtenprofiel om de permissies te bekijken</p>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <hr>
                    <b-form-checkbox v-model="item.send_invite" value=1 unchecked-value=0 class="mt-4 mb-2">
                      Stuur direct een uitnodiging aan deze gebruiker
                    </b-form-checkbox>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
            <b-col cols="12" v-can="'gebruikers aanpassen'">
              <b-card>
                <b-button type="submit" variant="primary" :disabled="buttonDisabled">Gebruiker toevoegen</b-button>
              </b-card>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
import { getData, addData } from '../../api';

export default {
  name: 'company-create',
  data() {
    return {
      companyOptions: [],
      locationOptions: [],
      roleOptions: [],
      buttonDisabled: false,
      item: {
        name: null,
        email: null,
        company_id: null,
        location_id: null,
        role: null,
        send_invite: 1,
      },
      errors: null,
      double_check: 0,
    }
  },
  methods: {
    async getCompanyOptions() {
      const options = await getData('companies/options').then(response => response.data);
      this.companyOptions = options.data.sort((a, b) => a.text > b.text ? 1 : a.text < b.text ? -1 : 0);
      this.companyOptions.unshift({ text: "Kies een bedrijf", value: null });
    },
    async getLocationOptions() {
      const locations = await getData('locations/options').then(response => response.data);
      this.locationOptions = locations.data.sort((a, b) => a.text > b.text ? 1 : a.text < b.text ? -1 : 0);
      this.locationOptions.unshift({ text: "Kies een locatie", value: null });
    },
    async getRoleOptions() {
      const roles = await getData('auth/roles').then(response => response.data);
      this.roleOptions = roles.data.map(item => ({text: item.name, value: item.name, permissions: item.permissions}));
    },
    async addItem() {
      this.errors = null;
      this.buttonDisabled = true;
      const data = this.item;
      const request = await addData('users', data);
      if (request.status === 200) {
        this.$router.push({ name: 'users.view', params: { id: request.data } });
      } else {
        this.errors = request.data.errors;
        this.buttonDisabled = false;
      }
    },
  },
  computed: {
    portalPermissions() {
      let permissions = [];

      if (this.item.role) {
        const profile = this.roleOptions.find(item => {
          return item.value === this.item.role
        });

        if (profile) {
          permissions = profile.permissions.map(item => {
            return {
              text: item.name,
              value: item.id,
              checked: true
            }
          });
        }
      }

      return permissions;
    },
    activePortalPermissions() {
      return this.portalPermissions.map(item => item.value);
    }
  },
  watch: {
    'item.role'(newValue) {
      this.item.company_id = null;
      this.item.location_id = null;
    }
  },
  beforeMount() {
    this.getCompanyOptions();
    this.getLocationOptions();
    this.getRoleOptions();
  }
}

</script>
